// Cabinet/BalanceTab.tsx

import React from 'react';
import {FC, FRSC} from 'WideLayout/Layouts';
import {getConsultationTypeLabel} from "Locale/ruMap";
import {useTheme} from "Theme/ThemeContext";

export interface BalanceItem {
    config__type__name: string;
    config__duration__value: number;
    config__is_online: boolean;
    config__is_supervision: boolean;
    count: number;
}

interface BalanceData {
    total_count: number;
    details: BalanceItem[];
}

interface BalanceTabProps {
    balanceData: BalanceData;
}

const BalanceTab: React.FC<BalanceTabProps> = ({balanceData}) => {
    const {plt} = useTheme();

    return (
        <FC g={1} p={2}>
            <h3 className='fs-5'>Консультаций на балансе: {balanceData?.total_count}</h3>
            {balanceData.details.map((item, index) => (
                <FC
                    key={index}
                    cls="balance-item"
                    p={2}
                    w={'min-content'}
                    bg={plt.colors.secondary.lighter}
                    rounded={3}
                >
                    <FC>
                        <FRSC gap={1}>
                            <span className='fs-4'>
                                {getConsultationTypeLabel(item.config__type__name)}
                            </span>
                            <div>
                                <span className={'text-nowrap'}>{`${item.count} шт.`}</span>
                            </div>
                        </FRSC>
                        <div>
                            <span>{`${item.config__duration__value} минут`}</span>
                        </div>
                        {item.config__is_online && <div>
                            <span>Онлайн</span>
                        </div>}
                        {item.config__is_supervision && <div>
                            <span>Супервизия</span>
                        </div>}
                    </FC>
                </FC>
            ))}
        </FC>
    );
};

export default BalanceTab;
